import React, {useState, useEffect} from 'react';
import KickImage from 'Reuseables/KickImage';
import { Modal } from "reactstrap"
import ModalEditAddressIdExpress from "./ModalEditAddressIdExpress"
import CloseIcon from '../../images/close-button-black.png';
import ArrowDown from "../../images/arrowsDown.png"
import { doFetchCities, doFetchProvinces, saveShipping, getHistoryShipping } from "../../actions/postalCodeAction"
import {connect} from "react-redux"
import InputNumber from 'Reuseables/InputNumber/InputNumber';

function ModalAddNewAddressIdExpress({isOpen, onToggle, title, countries, citiesData, isEdit, editId, dataAddress, provinceData, doFetchProvinces, doFetchCities, saveShipping, toggleAdd, changeId, getHistoryShipping}) {

  // Form data
  const [alias, setAlias] = useState("")
  const [fullName, setFullName] = useState("")
  const [countryPhoneCode, setCountryPhoneCode] = useState("62")
  const [phoneNumber, setPhoneNumber] = useState("")
  const [streetAddress, setStreetAddress] = useState("")
  const [countryCode, setCountryCode] = useState("")
  const [province, setProvince] = useState(null)
  const [city, setCity] = useState("")
  const [note, setNote] = useState("")
  const [postal_code, setPostalCode] = useState(null)
  const [showActiveButton, setShowActiveButton] = useState(false)

  useEffect(() => {
    if(alias && fullName && countryPhoneCode && phoneNumber && streetAddress && countryCode && province && city && postal_code){
      setShowActiveButton(true)
    } else {
      setShowActiveButton(false)
    }
  }, [alias, fullName, countryPhoneCode, phoneNumber, streetAddress, countryCode, province, city, postal_code])

  function handleCountryChange(e) {
    setCountryCode(e.target.value)
  }

  function handleCityChange(e) {
    setCity(e.target.value)
  }

  function handleProvinceChange(e) {
    setProvince(e.target.value)
  }

  async function addShipping(){
    try{
      const payload = {
        id: "",
        alias: alias,
        full_name: fullName,
        phone_number: `+${countryPhoneCode}${phoneNumber}`,
        street_address: streetAddress,
        country: countryCode,
        city,
        province,
        note,
        postal_code
      }
  
      await saveShipping(payload)
      await getHistoryShipping()
      onToggle()
    } catch(e) {
      console.log(e)
    }
  }

  function handlePhoneNumber(e){
    let event = e || window.event;

    // Handle key only accept number
    let key = event.keyCode || event.which
    key = String.fromCharCode(key)

    const regex = /[0-9]|\./

    if(!regex.test(key)){
      event.returnValue = false
      if(event.preventDefault) event.preventDefault()
    }
  }

  useEffect(() => {
    countryCode && doFetchProvinces(countryCode)
    .then(data => {
      setProvince(data.value.data[0].name)
    })
    .catch(e => null)
  }, [countryCode])

  useEffect(() => {
    province && doFetchCities(countryCode, province)
  }, [province])

  if(isEdit){
    return (
      <ModalEditAddressIdExpress toggleEdit={toggleAdd} isOpen={isOpen} data={dataAddress} id={editId} title={title} onToggle={onToggle} countries={countries} />
    )
  } else {
    return (
      <Modal isOpen={isOpen} toggle={onToggle}>
      <div className="add-address-container">
        <div className="add-address-header">
          <h4>{title}</h4>
          <div className="icon-close">
            <KickImage style={{cursor: "pointer"}} onClick={() => onToggle()} src={CloseIcon} alt="close"/>
          </div>
        </div>
        <div className="add-address-content">
          <div>
            <label>Save address as</label><br/>
            <input value={alias} onChange={(e) => setAlias(e.target.value)} type="text" placeholder="Save Address As (Ex. Office)" />
          </div>
          <div>
            <label>Recipient</label><br/>
            <input value={fullName} onChange={(e) => setFullName(e.target.value)} type="text" placeholder="Recipient" />
          </div>
          <div>
            <label>Phone Number</label><br/>
            <div className="add-address-phone-input">
              <select value={countryPhoneCode} onChange={(e) => setCountryPhoneCode(e.target.value)} style={{background: `url(${ArrowDown})`}}>
                {
                  countries && countries.map(item => (
                    <option value={item.phone_code}>{`+${item.phone_code}`}</option>
                  ))
                }
              </select>
              <InputNumber value={phoneNumber} onChange={(e) => setPhoneNumber(e.target.value)} placeholder="Phone Number" />
            </div>
          </div>
          <div>
              <label>Address</label><br/>
              <input value={streetAddress} onChange={(e) => setStreetAddress(e.target.value)} type="text" placeholder="Address" />
          </div>
          <div className="add-address-flex-inputs">
            <div>
                <label>Country</label><br/>
                <select onChange={handleCountryChange} style={{background: `url(${ArrowDown})`}} value={countryCode} name="" id="">
                <option value="" disabled selected>Select Country</option>
                {
                  countries && countries.map(item => (
                    <option value={item.code3}>{item.name}</option>
                  ))
                }
            </select>
            </div>
            <div>
              <label>Province</label><br/>
              <select value={province} onChange={handleProvinceChange} style={{background: `url(${ArrowDown})`}} name="" id="">
              <option value="" disabled selected>Select Province</option>
                {
                  provinceData && provinceData.map(item => (
                    <option value={item.name}>{item.name}</option>
                  ))
                }
              </select>
            </div> 
          </div>
          <div className="add-address-flex-inputs">
            <div style={{marginRight: "20px"}}>
              <label>City</label><br/>
              <select onChange={handleCityChange} style={{background: `url(${ArrowDown})`}} name="" id="">
              <option value="" disabled selected>Select City</option>
                {
                  citiesData && citiesData.map(item => (
                    <option value={item.name}>{item.name}</option>
                  ))
                }
              </select>
            </div>
          </div>
          <div>
            <label htmlFor="">Zip Code</label><br/>
            <input value={postal_code} onChange={(e) => setPostalCode(e.target.value)} type="number" placeholder="Enter Zip Code" />
          </div>
          <div>
            <label>Note</label><br/>
            <input value={note} onChange={(e) => setNote(e.target.value)} type="text" placeholder="Enter Note Here(Optional)" />
          </div>
        </div>
        <div className="add-address-footer">
          <span onClick={() => onToggle()}>Cancel</span>
          <span style={ showActiveButton ? {backgroundColor: "#242424", color: "#f1f1f1", cursor: "pointer"} : {backgroundColor: "#a7a7a7", border: "2px solid #a7a7a7", cursor: "normal"}} onClick={showActiveButton ? () => addShipping() : null}>Save</span>
        </div>
      </div>
      </Modal>
    )
  }
}

const mapStateToProps = state => ({
  provinceData: state.dataPostalCode.provinces.data,
  citiesData: state.dataPostalCode.cities.data
})

const mapDispatchToProps = dispatch => ({
  doFetchProvinces: country => dispatch(doFetchProvinces(country)),
  doFetchCities: (country, province) => dispatch(doFetchCities(country, province)),
  saveShipping: payload => dispatch(saveShipping(payload)),
  getHistoryShipping: () => dispatch(getHistoryShipping())
})

export default connect(mapStateToProps, mapDispatchToProps)(ModalAddNewAddressIdExpress)
